<template>
  <label class="radio-container" :for="id" :class="{ checked: id === value }"
    >{{ label }}
    <input
      type="radio"
      :name="name"
      :id="id"
      @input="$emit('input', id)"
      :checked="id === value"
    />
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  name: "radio-button",
  props: {
    value: String || Number,
    name: String,
    label: String,
    id: String,
  },
};
</script>

<style scoped lang="scss">
.radio-container {
  display: block;
  position: relative;
  padding: 10px 30px 10px 45px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  font-weight: 500;
  max-width: fit-content;
  &.checked {
    border: 1px solid $primaryColor;
    color: $primaryColor;
  }
}

/* Hide the browser's default radio button */
.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 10px;
  left: 16px;
  height: 16px;
  width: 16px;
  border: 1px solid #d2d2d2;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
  background-color: $primaryColor;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.radio-container + .radio-container {
  margin-left: toRem(22);
}
</style>